import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'
import type { MediaImage, Post } from '@/types/blog'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type LexicalNode = { type?: string; text?: string; children?: LexicalNode[] }

function nodeText(node: LexicalNode): string {
  if (typeof node.text === 'string') return node.text
  return (node.children ?? []).map(nodeText).join('')
}

export function getFirstParagraph(content: DefaultTypedEditorState | null | undefined): string {
  const children = (content?.root?.children ?? []) as LexicalNode[]
  for (const block of children) {
    if (block.type === 'paragraph') {
      const text = nodeText(block).trim()
      if (text) return text
    }
  }
  return ''
}

export function getExcerpt(post: Post): string {
  return post.excerpt || getFirstParagraph(post.content)
}

export function imageUrl(image: MediaImage | null | undefined, size?: string): string | null {
  if (!image) return null
  return (size && image.sizes?.[size]?.url) || image.url || null
}
